export default {
  socketConnection: null,
}
